import React from 'react';

import { IIconProps, TIconType } from '../interface';

const HalfCheckIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='21'
			viewBox='0 0 20 21'
			width='20'
			{...props?.innerSvgProps}
		>
			<rect
				fill='white'
				height='19'
				rx='3.5'
				stroke='#48428A'
				width='19'
				x='0.5'
				y='1'
			/>
			<rect
				fill='#48428A'
				height='8'
				rx='2'
				width='8'
				x='6'
				y='6.5'
			/>
		</svg>
	);
};

export default HalfCheckIcon;
